import Api from './Api';

class LogicBaseCollectionSubscriptionApi extends Api {
  url = 'logicbasecollectionsubscriptions';
}

const singleton = new LogicBaseCollectionSubscriptionApi();
export default singleton;
